var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading",style:({ minHeight: _vm.minHeight + 'px' })},[_c('div',{staticClass:"ball"})])
}
var staticRenderFns = []

export { render, staticRenderFns }